import { SellerFilter, MarketplaceFilter, ProductFilter } from "@/components/new-filters";
import { mapState } from 'vuex';
import FiltersFrame from "@/components/new-filters/FiltersFrame.vue";
import { EVENTS } from "@/utils";
import SegmentFilter from "@/components/new-filters/SegmentFilter.vue";
import FilterItemSelector from "@/components/new-filters/FilterItemSelector.vue";
import BrandFilter from "./new-filters/BrandFilter.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import EmptySegments from "@/components/EmptySegments.vue";
export default {
  name: "DashboardFilters",
  components: {
    SellerFilter,
    MarketplaceFilter,
    ProductFilter,
    FiltersFrame,
    SegmentFilter,
    FilterItemSelector,
    BrandFilter,
    EmptySegments
  },
  mixins: [LiteTableMixin],
  computed: {
    ...mapState({
      sellers_filter: state => state.dashboard_v2.sellers_filter,
      marketplaces_filter: state => state.dashboard_v2.marketplaces_filter,
      products: state => state.dashboard_v2.products,
      segments: state => state.dashboard_v2.segments,
      brands: state => state.dashboard_v2.brands
    }),
    showBrandsFilter() {
      return this.brands.defaultList.length > 1;
    }
  },
  methods: {
    async applySellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.apply();
        this.products.clearAndApply();
        this.segments.clearAndApply();
        window.$bus.trigger('showSuccess', {
          message: '⏳Fetching sub filters for sellers...  ',
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2_SELLERS_SUB_FILTERS, false);
        window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2);
      }
    },
    async applyMarketplaces() {
      if (this.marketplaces_filter.isModified) {
        this.marketplaces_filter.apply();
        this.products.clearAndApply();
        this.segments.clearAndApply();
        window.$bus.trigger('showSuccess', {
          message: '⏳Fetching sub filters for marketplace...  ',
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2_MARKETPLACES_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2);
      }
    },
    applyProducts() {
      if (this.products.isModified) {
        this.products.apply();
        window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2);
      }
    },
    applyBrands() {
      if (this.brands.isModified) {
        this.brands.apply();
        window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2);
      }
    },
    async applySegments() {
      if (this.segments.isModified) {
        this.segments.apply();
        window.$bus.trigger('showSuccess', {
          message: '⏳Fetching product filters for segments...  ',
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2_PRODUCTS_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2);
      }
    },
    async handleProductsCleared() {
      // window.$bus.trigger('showSuccess', {
      //     message: '⏳Refreshing...  ',
      //     visible: true,
      //     delay: 10
      // });
      // await window.$bus.trigger(EVENTS.REFRESH_DASHBOARD_V2);
    }
  }
};